<template>
  <div class="flex flex-col items-center p-5">
    <div class="flex flex-row items-center">
      <a
        class="flex flex-row items-center opacity-50 hover-opacity"
        href="https://benwinding.com/projects"
        target="_blank"
      >
        <svg
          id="i-link"
          class="mr-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="16"
          height="16"
          fill="none"
          stroke="currentcolor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        >
          <path
            d="M18 8 C18 8 24 2 27 5 30 8 29 12 24 16 19 20 16 21 14 17 M14 24 C14
          24 8 30 5 27 2 24 3 20 8 16 13 12 16 11 18 15"
          />
        </svg>
        <span class="mr-2">Made by Ben Winding</span>
        <img
          class="rounded-full"
          width="30"
          src="https://benwinding.com/images/pic.jpg"
          alt="benwinding logo"
        />
      </a>
    </div>
    <div class="flex flex-row items-center">
      <a
        class="flex flex-row items-center opacity-50 hover-opacity"
        href="https://github.com/benwinding/wealth-visualizer"
        target="_blank"
      >
        <svg
          id="i-link"
          class="mr-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="16"
          height="16"
          fill="none"
          stroke="currentcolor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        >
          <path
            d="M18 8 C18 8 24 2 27 5 30 8 29 12 24 16 19 20 16 21 14 17 M14 24 C14
          24 8 30 5 27 2 24 3 20 8 16 13 12 16 11 18 15"
          />
        </svg>
        <span class="mr-2">Source code</span>
        <svg
          id="i-github"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width="28"
          height="28"
        >
          <path
            stroke-width="0"
            fill="currentColor"
            d="M32 0 C14 0 0 14 0 32 0 53 19 62 22 62 24 62 24 61 24 60 L24 55 C17
          57 14 53 13 50 13 50 13 49 11 47 10 46 6 44 10 44 13 44 15 48 15 48 18
          52 22 51 24 50 24 48 26 46 26 46 18 45 12 42 12 31 12 27 13 24 15 22
          15 22 13 18 15 13 15 13 20 13 24 17 27 15 37 15 40 17 44 13 49 13 49
          13 51 20 49 22 49 22 51 24 52 27 52 31 52 42 45 45 38 46 39 47 40 49
          40 52 L40 60 C40 61 40 62 42 62 45 62 64 53 64 32 64 14 50 0 32 0 Z"
          />
        </svg>
        <img class="m-2" width="45" alt="MIT logo" src="https://i.imgur.com/z0VT0Qb.png" />
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>